type DelegateSettings = {
  externalProposalUrl: string
  message: string
  ctaLabel: string
}

// Hardcoded list of organizations with delegate settings
const EXTERNAL_PROPOSAL_REF: Record<
  string,
  Record<string, DelegateSettings>
> = {
  "https://api.tally.xyz": {
    // Glif-test: https://www.tally.xyz/gov/glif-test
    "2481432668122646008": {
      externalProposalUrl:
        "https://glif.io?network=calibrationnet&txtype=gliftokenproposal&txid={tallyProposalId}",
      message:
        "View the mirrored proposal on glif.io for Filecoin network voting",
      ctaLabel: "Open proposal on glif.io",
    },
    // Glif fake mainnet: https://www.tally.xyz/gov/glif-fake-mainnet
    "2546786097199842801": {
      externalProposalUrl:
        "https://glif.io?txtype=gliftokenproposal&txid={tallyProposalId}",
      message:
        "View the mirrored proposal on glif.io for Filecoin network voting",
      ctaLabel: "Open proposal on glif.io",
    },
    // Glif: https://www.tally.xyz/gov/glif
    "2360265506449000017": {
      externalProposalUrl:
        "https://glif.io?txtype=gliftokenproposal&txid={tallyProposalId}",
      message:
        "View the mirrored proposal on glif.io for Filecoin network voting",
      ctaLabel: "Open proposal on glif.io",
    },
  },
  "https://api.staging.tally.xyz": {
    // Glif-test: https://staging.tally.xyz/gov/glif-test
    "2385729119296948158": {
      externalProposalUrl:
        "https://glif.io?network=calibrationnet&txtype=gliftokenproposal&txid={tallyProposalId}",
      message:
        "View the mirrored proposal on glif.io for Filecoin network voting",
      ctaLabel: "Open proposal on glif.io",
    },
    // Test Glif DAO 2: https://staging.tally.xyz/gov/test-glif-dao-2
    "2505259449984222607": {
      externalProposalUrl:
        "https://glif.io?network=calibrationnet&txtype=gliftokenproposal&txid={tallyProposalId}",
      message:
        "View the mirrored proposal on glif.io for Filecoin network voting",
      ctaLabel: "Open proposal on glif.io",
    },
  },
}

export const getMirroredProposal = (
  organizationId: string,
): DelegateSettings | undefined => {
  return (
    EXTERNAL_PROPOSAL_REF?.[process.env.NEXT_PUBLIC_TALLY_API_URL]?.[
      organizationId
    ] ?? undefined
  )
}
